import styled from 'styled-components';

interface InputStyledProps {
  hasError: boolean;
  hasText: boolean;
}

const InputWrapper = styled.div`
  position: relative;
  display: block;

  > span {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 14px;
    letter-spacing: 0.4px;
    color: #666;
    margin: 4px 16px;
    -webkit-box-decoration-break: clone;
    box-decoration-break: clone;
  }
`;

const InputStyled = styled.div<InputStyledProps>`
  position: relative;
  display: block;

  > textarea {
    font-family: 'Arial';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 160%;
    bottom: 8px;
    background: ${({ hasError }) => (hasError ? '#FDCCD6' : '#fff')};
    transition: background-color 0.3s ease-in-out;
    border: 1px solid #999;
    box-sizing: border-box;
    border-radius: 8px;
    width: 100%;
    min-height: 54px;
    padding: ${({ hasText }) => (hasText ? '22px 16px 8px' : '')};
    color: #404040;
    resize: vertical;

    &.valid {
      border: 1px solid;
      border-color: ${({ hasError }) => (hasError ? '#ab0000' : '#009a00')};
    }

    &.invalid {
      border: 1px solid #ab0000;
    }

    &::placeholder {
      font-size: 14px;
      line-height: 16px;
      letter-spacing: 0.15px;
      opacity: 0;
    }

    &:focus {
      padding: 22px 16px 8px;
      transition: padding 0.2s ease-in-out;
      ~ label {
        top: 1px;
        left: 16px;
        width: calc(100% - 32px);
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 160%;
        letter-spacing: 0.15px;
        color: ${({ hasError }) => (hasError ? '#282828' : '#666')};
        background-color: ${({ hasError }) => (hasError ? '#FDCCD6' : '#fff')};
        padding: 5px 0px 0px 0px;
        transition: background-color 0.2s ease-in-out;
      }
    }

    &:focus,
    &:not(:placeholder-shown) {
      outline: none;

      &::placeholder {
        opacity: 0.7;
        font-family: 'Arial';
      }
    }
  }

  > label {
    margin: 1px 0 0;
    padding: 5px 0 0;
    font-style: normal;
    font-weight: 400;
    font-size: ${({ hasError, hasText }) => (hasError || hasText ? '12px' : '14px')};
    line-height: 160%;
    color: ${({ hasError }) => (hasError ? '#F80032' : '#575757')};
    position: absolute;
    pointer-events: none;
    left: 16px;
    top: ${({ hasError, hasText }) => (hasError || hasText ? '' : '10px')};
    transition: 0.2s ease-in-out all;
    -moz-transition: 0.2s ease-in-out all;
    -webkit-transition: 0.2s ease-in-out all;
    background-color: ${({ hasError }) => (hasError ? '#FDCCD6' : '#fff')};
    text-transform: ${({ theme }) => theme.titleTransform};

    &.valid {
      color: #009a00 !important;
    }

    &.invalid {
      color: #ab0000 !important;
    }
  }
`;

export default InputWrapper;
export { InputWrapper, InputStyled };
